import { useEffect, useState } from 'react';
import { Box, Button, Divider, IconButton, Stack, Tooltip } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { Icon as Iconify } from '@iconify/react';
import { alpha, styled } from '@mui/material/styles';
import { useLocation } from 'react-router';
import { DataGrid, gridClasses } from '@mui/x-data-grid';

import { useSchemeStore } from '../schemeStore';

import SchemeSlabPopup from '../Others/SchemeSlabPopUp';
import ConfirmationPopup from '../Others/ConfirmationPopup';


export default function SchemeSlab() {
    const location = useLocation();
    const isCopyScheme = location.state?.data?.copyScheme;

    const {
        schemeDetails,
        fetchSchemeSlabControls,
        slabData,
        setEditSlabData,
        setSlabData,
        setEditedSlabId,
        editedSlabId,
        setSlabMainGridData,
        definitionData,
        setSlabFormData,
        tabValue,
        prevTabValue,
        updateScheme,
        addScheme,
        schemeData,
        thresholdSettings
    } = useSchemeStore();


    useEffect(() => {
        // console.log("schemeData: ", schemeData);
    }, [schemeData]);

    useEffect(() => {
        console.log("thresholdSettings: ", thresholdSettings);
    }, [thresholdSettings]);

    useEffect(() => {
        fetchSchemeSlabControls()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function generateUniqueId() {
        return `id-${Math.random().toString(36).substr(2, 9)}-${Date.now()}`;
    }

    function mergeSlabData(slabData2, slabDisplayDetails) {
        return slabData2.map(slab => {
            const displayDetail = slabDisplayDetails.find(detail => detail.Id === slab.Id);
            const itemNames = displayDetail?.FreeItem?.split(',') || [];
            const giftName = displayDetail?.Gift || null;

            const enrichedRewards = slab.Reward.map(reward => {
                if (reward.FilterType === "Gift" && reward.GiftId) {
                    return {
                        ...reward,
                        GiftId: [
                            {
                                GiftId: reward.GiftId,
                                Gift: giftName
                            }
                        ]
                    };
                }

                if (reward.FilterType === "FreeItem" && Array.isArray(reward.ItemId)) {
                    return {
                        ...reward,
                        ItemId: reward.ItemId.map((id, index) => ({
                            ItemId: id,
                            Item: itemNames[index] || null
                        }))
                    };
                }

                return reward;
            });

            return {
                ...slab,
                Reward: enrichedRewards
            };
        });
    }





    const [openSlabPopup, setOpenSlabPopup] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false);

    const editSlab = (params) => {

        setOpenSlabPopup(true);
        //  console.log("params.row: ", params.row);
        setEditSlabData(params.row);
        //  console.log("params.row.id: ", params.row.Id);
        setEditedSlabId(params.row.id || params.row.Id)
    }

    const deleteSlab = (params) => {
        const deleteId = params.row.Id ?? params.row.id;
        setNewRows(prev => prev.filter(row => row.Id !== deleteId && row.id !== deleteId));
        setEditSlabData(null);
        setEditedSlabId(null);
    };

    const deleteAllSlabs = () => {
        setOpenConfirm(true);
    };

    const handleConfirmDeleteAll = (confirm) => {
        if (confirm) {
            setNewRows([]);
        }
        setOpenConfirm(false);
    };

    const handleSlabClose = () => {
        setOpenSlabPopup(false);
        setEditSlabData(null);

    }

    function transformSlabsPopupData(slabPopupData) {
        const slabMap = new Map();

        // Iterate over each type (discount, gift, freeItem)
        // eslint-disable-next-line no-restricted-syntax
        for (const [type, rewards] of slabPopupData.entries()) {
            // eslint-disable-next-line no-restricted-syntax
            for (const reward of rewards) {
                const slabKey = reward.SlabName;
                // Check if slab already exists, else create
                if (!slabMap.has(slabKey)) {
                    slabMap.set(slabKey, {
                        id: generateUniqueId(), // or use reward.id if needed
                        SlabName: reward.SlabName,
                        LiftingQuantity: reward.LiftingQuantity,
                        ContributionQuantity: reward.ContributionQuantity,
                        AdditionalRebate: reward.AdditionalRebate,
                        NegativeThresholdLimit: reward.NegativeThresholdLimit,
                        PositiveThresholdLimit: reward.PositiveThresholdLimit,
                        Reward: []
                    });
                }
                // Prepare the reward object based on type
                let rewardObj = {};
                if (type === "discount") {
                    rewardObj = {
                        FilterType: "Discount",
                        DiscountType: reward.DiscountType.DiscountType,
                        // DiscountTypeExp: reward.DiscountType.DiscountTypeExp, // Add this line if needed
                        DiscountRate: reward.DiscountRate
                    };
                } else if (type === "gift") {
                    rewardObj = {
                        FilterType: "Gift",
                        GiftId: [reward.GiftId],
                        GiftQty: reward.GiftQty
                    };
                } else if (type === "freeItem") {
                    rewardObj = {
                        FilterType: "FreeItem",
                        ItemId: reward.ItemId,
                        FreeQty: reward.FreeQty
                    };
                }
                // Add to the Reward array
                slabMap.get(slabKey).Reward.push(rewardObj);
            }
        }

        // Return as array
        //  console.log("transformResult: ", Array.from(slabMap.values()));
        return Array.from(slabMap.values());
    }

    const updateNewRows = (slabPopupData) => {
        const updatedRows = transformSlabsPopupData(slabPopupData);
        if (editedSlabId == null) {
            setNewRows(prev => [...prev, ...updatedRows]);
        } else {
            setNewRows(prev => {
                const index = prev.findIndex(row => row.Id === editedSlabId || row.id === editedSlabId);

                if (index === -1) {
                    return [...prev, ...updatedRows];
                }

                return [
                    ...prev.slice(0, index),
                    ...updatedRows,
                    ...prev.slice(index + 1)
                ];
            });

        }
    };





    useEffect(() => {
        const hasData = slabData instanceof Map
            ? slabData.size > 0
            : Array.isArray(slabData) && slabData.length > 0;

        if (hasData) {
            updateNewRows(slabData);
            setSlabData([]);
            setEditedSlabId(null);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slabData])



    function getRewardDetails(data) { // NOSONAR
        // Use a Map to group values by label
        const grouped = new Map();

        data.forEach(item => {
            if (item.FilterType === "Discount") {
                let label = "";
                if (item.DiscountType === "n") label = "Net";
                if (item.DiscountType === "p") label = "Percentage";
                if (item.DiscountType === "c") label = "Rs";

                if (!grouped.has(label)) grouped.set(label, []);
                grouped.get(label).push(item.DiscountRate);
            }
            else if (item.FilterType === "Gift") {
                item.GiftId.forEach(gift => {
                    const label = gift.Gift;
                    if (!grouped.has(label)) grouped.set(label, []);
                    grouped.get(label).push(item.GiftQty);
                });
            }
            else if (item.FilterType === "FreeItem") {
                item.ItemId.forEach(freeItem => {
                    const label = freeItem.Item;
                    if (!grouped.has(label)) grouped.set(label, []);
                    grouped.get(label).push(item.FreeQty);
                });
            }
        });

        // Build the final string
        const details = [];
        grouped.forEach((values, label) => {
            details.push(`${label} : ${values.join(', ')}`);
        });

        return details.join(', ');
    }



    // Output: Net : 5, Laptop : 5, ULTRASAFE X100L PR LIGHT AQUA SSL : 7



    useEffect(() => {
        if (!schemeDetails?.Slabs || !schemeDetails?.SlabDisplayDetails) return;

        const initialSlabData = mergeSlabData(schemeDetails?.Slabs, schemeDetails?.SlabDisplayDetails);
        //  console.log("initialSlabData: ", initialSlabData)
        if (Array.isArray(initialSlabData) && initialSlabData?.length > 0) {
            setNewRows(initialSlabData);
        }

        // Find the value from thresholdSettings
        const thresholdSetting = thresholdSettings?.find(
            (item) => item.Key === "ExceptionThresholdPositiveNegativeApplicable"
        );

        // Check if the setting is true
        const isPositiveNegativeApplicable = thresholdSetting?.Value === "false";


        const useWidth = definitionData?.AdditionalRebate || !isPositiveNegativeApplicable;

        const allColumns = [
            {
                field: 'slabName', headerName: 'Slab Name', ...(useWidth ? { width: 180 } : { flex: 1 }), valueGetter: (params) => params.row?.SlabName || ''
            },
            {
                field: 'liftingQuantity', headerName: 'Lifting Quantity', ...(useWidth ? { width: 180 } : { flex: 1 }),
                valueGetter: (params) => params.row?.LiftingQuantity || ''
            },
            {
                field: 'reward', headerName: 'Reward', ...(useWidth ? { width: 180 } : { flex: 1 }),
                valueGetter: (params) => [...new Set(params.row?.Reward.map(item => item.FilterType))].join(',') || ''
            },
            {
                field: 'rewardDetails',
                headerName: 'Reward Details',
                ...(useWidth ? { width: 200 } : { flex: 1 }),
                valueGetter: (params) => getRewardDetails(params.row?.Reward) || '',
                renderCell: (params) => (
                    <div style={{ whiteSpace: 'pre-wrap' }}>{params.value}</div>
                )
            },
            {
                field: 'additionalRebate',
                headerName: 'Additional Rebate',
                minWidth: 180,
                valueGetter: (params) => params.row?.ContributionQuantity || ''
            },
            {
                field: 'contributionQuantity',
                headerName: 'Contribution Quantity',
                minWidth: 180,
                valueGetter: (params) => params.row?.AdditionalRebate || ''
            },
            {
                field: 'negativeThresholdLimit',
                headerName: 'Negative Threshold Limit',
                minWidth: 180,
                valueGetter: (params) => params.row?.NegativeThresholdLimit || ''
            },
            {
                field: 'positiveThresholdLimit',
                headerName: 'Positive Threshold Limit',
                minWidth: 180,
                valueGetter: (params) => params.row?.PositiveThresholdLimit || ''
            },
            {
                field: 'edit',
                headerName: 'Edit',
                sortable: false,
                width: 80, // Set a fixed width for a smaller size
                renderCell: (params) => (
                    <IconButton sx={{ padding: 0 }} onClick={() => editSlab(params)}>
                        <Iconify icon="material-symbols:edit-outline" width="15px" height="15px" color="#1976d2" sx={{ padding: 0 }} />
                    </IconButton>
                ),
            },
            {
                field: 'delete',
                headerName: 'Delete',
                sortable: false,
                width: 100, // Set a fixed width for a smaller size  // Adjust flex as needed
                renderHeader: () => (
                    <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '8px' }}>

                        <IconButton
                            onClick={() => deleteAllSlabs()} title="Delete All"
                            sx={{ display: 'flex', alignItems: 'center', marginLeft: '0px', padding: '4px 8px 4px 0px' }}
                        >
                            <Iconify icon="fluent:delete-32-regular" width='15px' height='15px' color="red" />

                        </IconButton>
                        <span>Delete</span>
                    </div>
                ),
                renderCell: (params) => (
                    <IconButton onClick={() => deleteSlab(params)}>
                        <Iconify icon="fluent:delete-32-regular" width="15px" height="15px" color="red" />
                    </IconButton>
                ),
            }
        ];
        const filteredColumns = allColumns.filter((col) => {


            // Show Additional Rebate & Contribution Quantity columns only if AdditionalRebate is truthy
            if (
                !definitionData?.AdditionalRebate &&
                ['additionalRebate', 'contributionQuantity'].includes(col.field)
            ) {
                return false;
            }

            // Hide Threshold Limit columns if isPositiveNegativeApplicable is null, undefined, or empty string
            if (
                isPositiveNegativeApplicable &&
                ['negativeThresholdLimit', 'positiveThresholdLimit'].includes(col.field)
            ) {
                return false;
            }

            return true;
        });



        // Now set columns

        setColumns(filteredColumns);



        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [schemeDetails, schemeData?.AdditionalRebate, schemeData?.ThresholdPercentage]);


    const [newRows, setNewRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [pageSize, setPageSize] = useState(100);


    useEffect(() => {
        setSlabMainGridData(newRows);
        //  console.log("newRows: ", newRows);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newRows]);

    const { handleSubmit } = useForm({
        defaultValues: {}
    });


    // eslint-disable-next-line arrow-body-style
    const transformRows = (rows) => { // NOSONAR
        return rows.map((row, index) => {
            const { id, ...rowsData } = row;
            return (
                ({
                    ...rowsData,
                    Id: index + 1,
                    Reward: row.Reward.map((reward) => {
                        if (reward.FilterType === "FreeItem") {
                            return {
                                ...reward,
                                ItemId: reward.ItemId.map((item) =>
                                    typeof item === 'object' ? item.ItemId : item
                                ),
                            };
                        }

                        if (reward.FilterType === "Gift") {
                            return {
                                ...reward,
                                // eslint-disable-next-line no-nested-ternary
                                GiftId: Array.isArray(reward.GiftId) && reward.GiftId.length > 0
                                    ? (typeof reward.GiftId[0] === 'object' ? reward.GiftId[0].GiftId : reward.GiftId[0]) // NOSONAR
                                    : reward.GiftId,
                            };
                        }

                        return reward;
                    }),
                })
            )
        });
    };

    useEffect(() => {
        if (prevTabValue.name === 'Slab') {
            formDataSave();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabValue]);

    const formDataSave = async () => {
        const transformedPayload = transformRows(newRows);
        if (transformedPayload?.length === 0) {
            setSlabFormData('error');

        } else {

            setSlabFormData(transformedPayload);
        }



    }




    const onSubmit = async () => {
        const transformedPayload = transformRows(newRows);
        if (transformedPayload?.length === 0) {
            setSlabFormData('error');

        } else {

            setSlabFormData(transformedPayload);
        }

        try {
            if (isCopyScheme) {
                const result = await addScheme(); // NOSONAR
            } else {

                const result = await updateScheme(); // NOSONAR
            }
        } catch (err) {
            // handle error
        }
    };

    const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
        [`& .${gridClasses.columnHeader}`]: {
            backgroundColor: 'white',
            color: 'black',
            fontWeight: 'bold',
            fontSize: '13px', // Adjust font size if needed
            lineHeight: '40px',  // Keep line height consistent
            paddingLeft: '5px', // Remove left padding

        },

        '& .MuiDataGrid-cell': {
            borderTop: `1px solid ${alpha(theme.palette.divider, 0.3)}`, // Top border for all cells
            fontSize: '13px', // Adjust font size if needed
            padding: '4px 5px', // Adjust padding to remove vertical space
            display: 'flex', // Ensure the content is aligned top
            alignItems: 'flex-start', // Align content at the top
            whiteSpace: 'normal', // Allow text to wrap
            wordWrap: 'break-word', // Ensure long words break and wrap to the next line
            overflow: 'visible',  // Make sure overflow content is visible
            height: 'auto', // Allow the cell height to expand based on content
            '&:hover': {
                backgroundColor: 'white',
            },
        },

        // Remove top border for first row
        '& .MuiDataGrid-row:first-child .MuiDataGrid-cell': {
            borderTop: 'none',  // No top border for the first row
        },

        '& .MuiDataGrid-row:last-child .MuiDataGrid-cell': {
            borderBottom: `1px solid ${alpha(theme.palette.divider, 0.3)}`,  // Bottom border for last row
        },

        '& .MuiDataGrid-row': {
            minHeight: '45px',  // Ensure no extra space vertically for rows
            display: 'flex', // Align rows as flex containers
            alignItems: 'stretch', // Stretch row content to match height
            '&:hover': {
                backgroundColor: 'white',
            },
            padding: '0px 0px'

        },

        '& .MuiDataGrid-columnSeparator': {
            display: 'none',
        },

        '& .MuiDataGrid-menuIcon': {
            display: 'none',
        },



    }));

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%', // Make sure parent takes full height
        }}>
            <FormProvider >
                <form
                    onSubmit={handleSubmit(onSubmit)}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        minHeight: 0, // Enables child to grow correctly inside a flex container
                    }}
                >
                    <Stack direction="row" justifyContent="flex-end" alignItems="flex-end" spacing={2} sx={{ my: 1 }}>
                        <Tooltip title="Add" arrow>
                            <Button
                                type="button"
                                onClick={() => {
                                    setEditSlabData(null);
                                    setEditedSlabId(null);
                                    setOpenSlabPopup(true);
                                }}
                                variant="contained"
                                sx={{
                                    height: '30px',
                                    width: '31px',
                                    bgcolor: '#1badd1',
                                    borderRadius: '4px',
                                    minWidth: 'auto',
                                    fontSize: '25px',
                                    '&:hover': {
                                        bgcolor: '#1badd1',
                                    },
                                }}
                            >
                                +
                            </Button>
                        </Tooltip>
                    </Stack>

                    <Divider sx={{ mt: 1 }} />
                    <div style={{
                        flexGrow: 1,
                        overflowY: 'auto',
                        overflowX: 'auto',
                        minHeight: 0,
                    }}>

                        <StripedDataGrid
                            rows={newRows}
                            columns={columns}
                            pageSize={pageSize}
                            disableSelectionOnClick
                            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                            getRowId={(row) => row.id || row.Id}
                            localeText={{ noRowsLabel: '' }}

                            components={{
                                Pagination: null
                            }}
                            sx={{
                                height: '100%',
                                '& .css-1vjh543-MuiDataGrid-footerContainer': {
                                    minHeight: 0
                                },
                                '& .css-1t5atbe-MuiDataGrid-root .MuiDataGrid-row': {
                                    paddingBottom: '0px',
                                    height: 'fit-content', // Adjust row height based on content
                                },
                                '& .css-1t5atbe-MuiDataGrid-root .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight) > .MuiDataGrid-cell': {
                                    whiteSpace: 'pre-wrap', // Proper white-space handling for wrapping
                                    lineHeight: 1,
                                    wordWrap: 'break-word',
                                }
                            }}
                            getRowHeight={() => "auto"}
                            headerHeight={35} // Set row height globally                 
                            hideFooterPagination
                            hideFooter


                        />


                    </div>

                    {/* Divider */}
                    <Divider sx={{ mt: 2 }} />

                    {/* Save button fixed at the bottom */}
                    <Box sx={{ mt: 1 }}>
                        <Stack
                            direction="row"
                            justifyContent="flex-end"
                            spacing={2}
                            alignItems="center"
                            sx={{ padding: '2px' }}
                        >
                            {schemeDetails?.SchemeLock !== true && (
                                <Tooltip title="Save">
                                    <IconButton type="submit" sx={{
                                        bgcolor: '#43b5a2',
                                        color: '#fff',
                                        borderRadius: '4px',
                                        height: '30px',
                                        width: '31px',
                                        padding: '4px',
                                    }}>
                                        <Iconify icon="bx:save" />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Stack>
                    </Box>




                </form>
                {openSlabPopup && (
                    <SchemeSlabPopup

                        confirm={handleSlabClose}
                    />
                )}
                {openConfirm && (
                    <ConfirmationPopup
                        open={openConfirm}
                        setOpen={setOpenConfirm}
                        onConfirm={handleConfirmDeleteAll}
                        title="Delete All"
                        msg="Are you sure you want to delete all slabs?"
                    />
                )}
            </FormProvider>
        </div>
    )
}

